module.exports = __webpack_public_path__ + "media/images/product_owners/pm_amsa_90-df52da29cb529d74ab4d407f4640b1a4.png";